import { useLocation } from "react-router-dom";
import { brand } from "@/mocks/siteData";
import { getAbsoluteUrl } from "@/components/feature/Seo";

const LOGO_URL =
  "https://static.readdy.ai/image/20debd2956563c6417457fe0fe408adc/7e217269f5a0a1e17604c7a1688b9146.png";

/**
 * Site-wide schema.org structured data (Organization + WebSite), emitted once
 * for the whole public site. URLs are built from the site's locked canonical
 * origin (see getAbsoluteUrl), so the markup names the apex domain even when
 * the page was served on www or a preview host. It never renders inside the
 * admin portal.
 */
export default function SiteSchema() {
  const { pathname } = useLocation();

  if (pathname.startsWith("/admin")) return null;

  const origin = getAbsoluteUrl("/");

  const data = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": `${origin}#organization`,
        name: brand.fullName,
        alternateName: brand.name,
        url: origin,
        logo: LOGO_URL,
        slogan: brand.tagline,
        description:
          "Rythugaru Agri Tourism connects people with real farms, farmers and village life in rural India, offering authentic farm and village experiences across Konaseema, Andhra Pradesh.",
        email: brand.email,
        telephone: brand.phone,
        areaServed: brand.region,
        address: {
          "@type": "PostalAddress",
          addressLocality: "Konaseema",
          addressRegion: "Andhra Pradesh",
          addressCountry: "IN",
        },
      },
      {
        "@type": "WebSite",
        "@id": `${origin}#website`,
        url: origin,
        name: brand.fullName,
        inLanguage: "en",
        publisher: { "@id": `${origin}#organization` },
      },
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}